import { Helmet } from 'react-helmet-async';
import LocalVisibility from 'src/sections/overview/dashboards/views/visibility/local';

export default function VisibilityLocal() {
  return (
    <>
      <Helmet>
        <title>Local</title>
      </Helmet>

      <LocalVisibility />
    </>
  );
}
